import { useMutation, useQueryClient } from '@tanstack/react-query';

import axios, { parseAxiosError } from '@/portainer/services/axios/axios';
import { withError } from '@/react-tools/react-query';

import { BackupLocalModel } from '../types';

import { buildUrl } from './backupSettings.service';
import { queryKeys } from './queryKeys';

export function useUpdateBackupLocalSettingsMutation() {
  const queryClient = useQueryClient();

  return useMutation(updateBackupLocalSettings, {
    onSuccess: () => {
      queryClient.invalidateQueries(queryKeys.backupLocalSettings());
      queryClient.invalidateQueries(queryKeys.backupLocalStatus());
    },
    ...withError('Unable to save local backup settings'),
  });
}

async function updateBackupLocalSettings(payload: BackupLocalModel) {
  try {
    const response = await axios.post(buildUrl('local', 'settings'), payload);

    return response.data;
  } catch (e) {
    throw parseAxiosError(e as Error, 'Unable to save local backup settings');
  }
}
